// extracted by mini-css-extract-plugin
export default {"ourHostel":"OurHostel_ourHostel__3DLID","ourHostelContainer":"OurHostel_ourHostelContainer__zNzF9"};